import {
  createNewLead,
  fetchLeads,
  addNewNote,
  deleteALead,
  closeALead,
  updateLead,
} from "../../apis/leadAPI"
import {
  leadResponseSuccess,
  getLeadsSuccess,
  getSelectedLead,
  leadFail,
  isPending,
} from "./leadSlice"
import { toast } from "react-toastify"
import { userLogOut } from "../admin-dashboard-page/userAction"

export const newLeadAction = (obj) => async (dispatch) => {
  dispatch(isPending())
  const { params, ...rest } = obj
  const result = await createNewLead(rest)

  if (result?.message === "logout user") {
    return dispatch(userLogOut())
  }

  result.status === "success"
    ? dispatch(leadResponseSuccess(result.leads)) &&
      toast.success(result.message) &&
      dispatch(fetchLeadsAction(params))
    : dispatch(leadFail(result)) && toast.warn(result.message)
}

export const addNoteAction = (obj) => async (dispatch) => {
  dispatch(isPending())

  const result = await addNewNote(obj)

  if (result?.message === "logout user") {
    return dispatch(userLogOut())
  }

  result.status === "success"
    ? dispatch(leadResponseSuccess(result.leads)) &&
      toast.success(result.message) &&
      dispatch(fetchSingleLeadAction(obj._id))
    : dispatch(leadFail(result)) && toast.warn(result.message)
}

export const fetchLeadsAction = (params) => async (dispatch) => {
  dispatch(isPending())

  if (params !== "branch=all") {
    const result = await fetchLeads({ params })
    result.status === "success"
      ? dispatch(getLeadsSuccess(result.leads))
      : dispatch(leadFail(result))

    return
  }
  const result = await fetchLeads()

  if (result?.message === "logout user") {
    return dispatch(userLogOut())
  }

  result.status === "success"
    ? dispatch(getLeadsSuccess(result.leads))
    : dispatch(leadFail(result)) && toast.warn(result.message)
}

export const fetchSingleLeadAction = (_id) => async (dispatch) => {
  if (!_id) return

  dispatch(isPending())

  const result = await fetchLeads({ _id })

  if (result?.message === "logout user") {
    return dispatch(userLogOut())
  }

  result.status === "success"
    ? dispatch(getSelectedLead(result.leads))
    : dispatch(leadFail(result)) && toast.error(result.message)
}

export const deleteLeadAction = (obj) => async (dispatch) => {
  dispatch(isPending())
  const { _id, par } = obj
  const result = await deleteALead(_id)

  if (result?.message === "logout user") {
    return dispatch(userLogOut())
  }

  result.status === "success"
    ? dispatch(leadResponseSuccess(result.result)) &&
      dispatch(fetchLeadsAction(par)) &&
      toast.success(result.message)
    : dispatch(leadFail(result)) && toast.warn(result.message)
}

export const closeLeadAction = (_id) => async (dispatch) => {
  dispatch(isPending())

  const result = await closeALead(_id)

  if (result?.message === "logout user") {
    return dispatch(userLogOut())
  }

  result.status === "success"
    ? dispatch(leadResponseSuccess(result.result)) &&
      dispatch(fetchSingleLeadAction(_id)) &&
      toast.success(result.message)
    : dispatch(leadFail(result)) && toast.warn(result.message)
}

export const updateLeadAction = (obj) => async (dispatch) => {
  dispatch(isPending())
  const { status, message } = await updateLead(obj)

  status === "success"
    ? dispatch(leadResponseSuccess({ status, message })) &&
      dispatch(fetchSingleLeadAction(obj._id)) &&
      toast[status](message)
    : dispatch(leadFail({ status, message })) && toast[status](message)
}
